import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailType } from 'constants.js';
import stringHelper from 'utils/stringHelper';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';

const styles = theme => ({
    formControl: {
        width: '100%'
    },
    detailValue: {
        paddingLeft: theme.spacing(4)
    }
});

/* Liste des réponses possibles */
const reponses = [
    'Justifié',
    'Non justifié'
];

class BLCorrectifDialogContent extends React.Component {

    state = {
        commentaire: "",
        resultat: null,
        numeroPiece: ''
    };

    componentDidMount() {
        this.props.onChange(null);
    }
    
    getActionData(newState) {
        const { action} = this.props;

        if (newState.resultat === null) {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.numeroPiece)) {
            return null;
        }
        
        let actionData = {
            code: action.code,
            details: [{
                code: "NUMERO_PIECE",
                type: ReclamationActionDetailType.Texte,
                libelle: "Numéro de BL",
                position: 0,
                valeurString: newState.numeroPiece
            }]
        };
    
        {
            let detail = {
                code: "RESULTAT",
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: "Type : ",
                position: actionData.details.length,
                valeurString: reponses[newState.resultat],
                valeurInteger: newState.resultat
            };
            actionData.details.push(detail);
        }
                     
        if (newState.commentaire) {

            let detail = {
                code: "COMMENTAIRE",
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: newState.commentaire
            };

            actionData.details.push(detail);
        }
        
        return actionData;
    }
    
    handleChange = (event) => {

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }
    
    render() {
        const { classes } = this.props;
        const { commentaire, resultat, numeroPiece } = this.state;

        return (
            <DialogContent>
                <TextField className={classes.formControl}
                    required
                    id="numeroPiece"
                    name="numeroPiece"
                    label="Numéro de BL pour renvoi"
                    placeholder="Numéro de BL"
                    multiline
                    margin="normal"
                    value={numeroPiece}
                    onChange={this.handleChange}
                />
                               
                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">Type : </FormLabel>
                    <RadioGroup
                        aria-label="Type"
                        name="resultat"
                        className={classes.group}
                        value={resultat}
                        onChange={this.handleChange}
                    >
                        {reponses.map((reponse, index) => (
                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                        ))}
                    </RadioGroup>
                </FormControl>

                <TextField className={classes.formControl}
                    id="commentaire"
                    name="commentaire"
                    label="Commentaire"
                    placeholder="Commentaire"
                    multiline
                    margin="normal"
                    value={commentaire}
                    onChange={this.handleChange}
                />
            </DialogContent>
        );
    }
}

BLCorrectifDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(BLCorrectifDialogContent);